module.exports = __webpack_public_path__ + "img/feiqiu-bg.ad4d161b.png";